module.exports = __webpack_public_path__ + "static/img/zfb_pay1.1f121cdc.jpg";